import React from "react";
import cn from "classnames";
import styles from "./styles.css";

const Input = ({ className, ...rest }) => (
  <input
    {...rest}
    className={cn(styles.input, className)}
    type="search"
    autoCapitalize="none"
    autoComplete="off"
    autoCorrect="off"
    spellCheck="false"
    required
  />
);

Input.defaultProps = {
  placeholder: "Search Lonely Planet",
};

export default Input;
